/* One mobile navigation for every storefront layout. Native dialog provides focus containment. */
(() => {
  if (window.mrMobileNavigation) return;
  window.mrMobileNavigation = true;
  let cleanup = () => {};

  const init = () => {
    cleanup();
    const root = document.querySelector('[data-mrm-root]');
    if (!root) return;
    const dialog = root.querySelector('dialog');
    const opener = root.querySelector('[data-mrm-open]');
    const media = window.matchMedia('(max-width: 1199px)');
    const abort = new AbortController();
    const options = { signal: abort.signal };
    let scrollPosition = 0;
    let bodyStyles = null;
    const styleProperties = ['position', 'top', 'left', 'right', 'width', 'overflow'];

    const unlock = () => {
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mrm-is-open');
      if (!bodyStyles) return;
      styleProperties.forEach((property) => {
        const saved = bodyStyles[property];
        if (saved.value) document.body.style.setProperty(property, saved.value, saved.priority);
        else document.body.style.removeProperty(property);
      });
      bodyStyles = null;
      window.scrollTo({ top: scrollPosition, behavior: 'instant' });
    };
    const close = () => {
      if (dialog.open) dialog.close();
      unlock();
    };
    const open = () => {
      if (!media.matches || dialog.open) return;
      scrollPosition = window.scrollY;
      bodyStyles = Object.fromEntries(styleProperties.map((property) => [property, {
        value: document.body.style.getPropertyValue(property),
        priority: document.body.style.getPropertyPriority(property)
      }]));
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('mrm-is-open');
      opener.setAttribute('aria-expanded', 'true');
      dialog.showModal();
    };
    opener.addEventListener('click', open, options);
    dialog.addEventListener('close', () => { if (!dialog.open) unlock(); }, options);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-mrm-close]')) {
        close();
        return;
      }
      const toggle = event.target.closest('.mrm-submenu-toggle');
      if (toggle) {
        const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        submenu.hidden = expanded;
      }
      if (event.target.closest('a[href]')) close();
    }, options);
    media.addEventListener('change', () => { if (!media.matches) close(); }, options);
    window.addEventListener('pagehide', close, options);
    document.addEventListener('cart:updated', (event) => {
      const count = event.detail?.cart?.item_count;
      if (typeof count !== 'number') return;
      const badge = root.querySelector('[data-mrm-cart-count]');
      badge.textContent = `(${count})`;
      badge.hidden = count === 0;
    }, options);
    cleanup = () => { close(); abort.abort(); };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-mrm-root]')) init();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-mrm-root]')) cleanup();
  });
})();
